var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnemy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 88,
    viewBox: "0 0 96 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.4041 65.1712L51.0027 8.4193C48.9795 5.99629 46.1918 4.54381 43.1699 4.88582C40.148 5.22784 37.3237 7.31548 36.3249 10.0805L8.6545 74.6499C7.22405 77.4638 7.61919 80.955 9.64234 83.378C11.2338 85.8499 14.4532 87.2535 17.4751 86.9115L86.547 79.0941C89.5689 78.752 92.3932 76.6644 93.3919 73.8994C94.8224 71.0855 94.4272 67.5942 92.4041 65.1712V65.1712ZM41.6317 33.7898C41.3353 31.1713 43.2469 28.745 45.8371 28.4518C48.4273 28.1587 50.8327 30.0964 51.1291 32.7149L53.3023 51.9168C53.5987 54.5352 51.6871 56.9616 49.0969 57.2547C46.5067 57.5479 44.1013 55.6101 43.8049 52.9917L41.6317 33.7898ZM51.0232 74.2746C46.7062 74.7632 45.3983 70.9333 45.2007 69.1876C45.0032 67.442 45.422 63.4166 49.739 62.928C54.056 62.4394 55.3639 66.2694 55.5615 68.015C55.7591 69.7607 55.3402 73.786 51.0232 74.2746Z",
    fill: "#D2EEE0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnemy);
export default __webpack_public_path__ + "static/media/enemy.8c5f67cf.svg";
export { ForwardRef as ReactComponent };